import { render, staticRenderFns } from "./cookies.vue?vue&type=template&id=5c383619&scoped=true"
import script from "./cookies.vue?vue&type=script&lang=js"
export * from "./cookies.vue?vue&type=script&lang=js"
import style0 from "./cookies.vue?vue&type=style&index=0&id=5c383619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c383619",
  null
  
)

export default component.exports